module.exports = require("vue");


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 64
// module chunks = 0